<template>
  <v-container class="pb-12">
    <h1 class="text-h6">Vos cours</h1>

    <h1 class="text-subtitle-1">
      Seuls les cours que vous donnez se trouvent dans cette liste
    </h1>

    <v-divider class="mt-2 mb-6"></v-divider>

    <v-list class="elevation-1" two-line>
      <v-list-item v-if="cursusAreLoading">
        <v-list-item-content>
          <v-list-item-title>Chargement...</v-list-item-title>

          <v-list-item-subtitle>
            <v-progress-linear
              color="primary"
              indeterminate
            ></v-progress-linear>
          </v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>

      <v-list-item v-else-if="teacherCursus.length === 0">
        <v-list-item-content>
          <v-list-item-title>
            Vous n'avez pas de cours que vous pouvez scinder
          </v-list-item-title>

          <v-list-item-subtitle>
            Vous pensez qu'il s'agit d'une erreur ? Si le problème persiste, contactez le support
          </v-list-item-subtitle>
        </v-list-item-content>

        <v-list-item-action>
          <v-btn
            color="primary"
            icon
            @click="$emit('reload-cursus')"
          >
            <v-icon>mdi-reload</v-icon>
          </v-btn>
        </v-list-item-action>
      </v-list-item>

      <template v-else>
        <v-list-item v-for="(item, index) in teacherCursus" :key="index">
          <v-list-item-content>
            <v-list-item-title v-html="item.fullname"></v-list-item-title>

            <v-list-item-subtitle>{{ item.id_number }}</v-list-item-subtitle>

            <v-list-item-subtitle>{{ item.teachers.join(', ') }}</v-list-item-subtitle>
          </v-list-item-content>

          <v-list-item-action v-if="item.has_mutliple_teachers && !item.duplicate">
            <duplicate-cursus-dialog
              :cursus="item"
            ></duplicate-cursus-dialog>
          </v-list-item-action>

          <v-list-item-action v-else-if="item.duplicate">
            <delete-cursus-dialog
              :cursus="item"
              :disabled="item.end_date"
            ></delete-cursus-dialog>
          </v-list-item-action>

          <v-list-item-action>
            <registration-cursus-dialog
              :cursus="item"
            ></registration-cursus-dialog>
          </v-list-item-action>
        </v-list-item>
      </template>
    </v-list>
  </v-container>
</template>

<script>
import { mapState } from 'vuex';
import DuplicateCursusDialog from '@/components/DuplicateCursusDialog.vue';
import DeleteCursusDialog from '@/components/DeleteCursusDialog.vue';
import RegistrationCursusDialog from '@/components/RegistrationCursusDialog.vue';

export default {
  name: 'TeacherCursusList',

  components: {
    'duplicate-cursus-dialog': DuplicateCursusDialog,
    'delete-cursus-dialog': DeleteCursusDialog,
    'registration-cursus-dialog': RegistrationCursusDialog,
  },

  computed: {
    ...mapState(['teacherCursus', 'cursusAreLoading']),
  },
};
</script>
